import React, { useState } from "react";
import { X } from "lucide-react";
import { PAGES } from "../../App";
import { MEMBER_HOME } from "../../lib/access";

const GROUPS = [
  ["Underwriting", ["dashboard", "evaluation", "assumptions", "borrowingbase", "returns", "sourcesuses", "profitloss", "sensitivity", "assistant", "rollup"]],
  ["Capital", ["capital", "inbox", "lenders", "investors", "placement", "dealroom", "teaser", "docs", "intel"]],
  ["Sourcing & firm", ["firm", "portfolio", "scout", "closed", "loi", "pipeline", "nnn", "export"]],
];

export const AccessPicker = ({ value, onChange, onDone }) => {
  const [mode, setMode] = useState(value?.length ? "tabs" : "all");
  const [tabs, setTabs] = useState(value || []);
  const toggle = (id) => setTabs((t) => (t.includes(id) ? t.filter((x) => x !== id) : [...t, id]));
  const label = (id) => PAGES.find((p) => p.id === id)?.label || id;
  return (
    <div className="acc-picker" data-testid="access-picker">
      <div className="acc-top">
        <div className="acc-modes">
          <label className={`acc-mode ${mode === "all" ? "on" : ""}`}><input type="radio" checked={mode === "all"} onChange={() => setMode("all")} data-testid="access-all" />Entire deal — every tab</label>
          <label className={`acc-mode ${mode === "tabs" ? "on" : ""}`}><input type="radio" checked={mode === "tabs"} onChange={() => setMode("tabs")} data-testid="access-tabs" />Only these tabs</label>
        </div>
        <button className="btn btn-sm acc-close" onClick={() => onDone?.()} title="Close" data-testid="access-close"><X size={13} /></button>
      </div>
      {mode === "tabs" && (
        <div className="acc-groups">
          {GROUPS.map(([g, ids]) => (
            <div key={g} className="acc-group">
              <div className="acc-g-title">{g}</div>
              {ids.filter((id) => id !== MEMBER_HOME && PAGES.some((p) => p.id === id)).map((id) => (
                <label key={id} className={`acc-tab ${tabs.includes(id) ? "on" : ""}`}>
                  <input type="checkbox" checked={tabs.includes(id)} onChange={() => toggle(id)} data-testid={`access-tab-${id}`} />{label(id)}
                </label>
              ))}
            </div>
          ))}
        </div>
      )}
      <div className="acc-foot">
        <span className="cm-empty">{mode === "all" ? "They'll see the whole deal, like a partner." : tabs.length ? `${tabs.length} tab(s) selected` : "Pick at least one tab"}</span>
        <button className="btn btn-primary btn-sm" disabled={mode === "tabs" && !tabs.length} onClick={() => { onChange(mode === "all" ? [] : tabs); onDone?.(); }} data-testid="access-save">Save access</button>
      </div>
    </div>
  );
};
